import { render } from "./contextMenu.vue?vue&type=template&id=beb27b26&scoped=true"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"

import "./contextMenu.vue?vue&type=style&index=0&id=beb27b26&scoped=true&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb27b26"]])

export default __exports__